<template>
  <div class="orderdetail">
    <cube-page type="orderdetail-view" title="详情">
      <div slot="content">
        <div class="box-main">
          <div class="box" v-if="reservation">
            <h3>团队名称：{{ reservation.team_name || '暂无' }}</h3>
            <div class="list">
              <div class="list-item">
                <span>出团日期：</span>
                <span>{{ reservation.start_time || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>完团日期：</span>
                <span>{{ reservation.end_time || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>天数：</span>
                <span>{{ reservation.play_days || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>人数：</span>
                <span>{{ reservation.team_number || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>类型：</span>
                <span>{{ reservation.team_type_text || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>职级：</span>
                <span>{{ reservation.guide_rank_text || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>性别：</span>
                <span>{{ reservation.gender_text || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>语种：</span>
                <span>{{ reservation.lang_text || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>擅长：</span>
                <span>{{ reservation.skill_text || '暂无' }}</span>
              </div>
              <div class="list-item">
                <span>价格：</span>
                <span>{{ reservation.total_price || '暂无' }}</span>
              </div>
              <div class="list-item" style="display: flex;">
                <span>行程：</span>
                <span style="" v-html="reservation.trip_text || '暂无'"></span>
              </div>
              <div class="list-item">
                <span>状态：</span>
                <span style="color: red">{{ reservation.status_text || '暂无' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-btn">
          <van-button type="info" :loading="loading" @click="handleStatus">接单</van-button>
        </div>
      </div>
    </cube-page>
  </div>
</template>

<script>
import CubePage from '../../TP/cube-page.vue'
import * as util from '@/utils/network'
import {
  Toast,
} from 'vant';

export default {
  components: {
    CubePage,
  },
  data() {
    return {
      reservation: null,
      showMemo: false,
      message: '',
      onlyId: '',
      autosize: {
        minHeight: 100
      },
      loading: false
    };
  },
  mounted() {
    this.onlyId = this.$route.query.id;
    this.getData(this.onlyId)
  },
  methods: {
    getData(id) {
      let that = this;
      var url = "/addons/litestore/api.guide/item"
      //这里直接调用网络接口
      util.get(url, { id }, (result) => {
        if (result.data != null) {
          that.reservation = result.data;
        }
      });
    },
    handleStatus() {
      this.loading = true;
      this.$dialog.confirm({
        title: '提示',
        message: '确认进行接单操作吗？'
      }).then(() => {
        let url = '/addons/litestore/api.guide/accept';
        util.post(url, { id: this.onlyId }, (result) => {
          if (result.code == 1 || result.code == 2002) {
            Toast(result.msg)
            let path = '/guideTravelOrder';
            if (result.code == 2002) {
              path = '/guideApply'
            }
            setTimeout(() => {
              //跳转至订单
              this.$router.push({
                path,
              })
            }, 1000);
          }
        });
      }).catch(() => { });
      setTimeout(() => {
        this.loading = false;
      }, 2000)
    },
  },
}
</script>
<style lang="less" scoped="scoped">
.box-main {
  padding: 20px;

  .box {
    padding: 10px 0;
    background: #fff;
    border-radius: 8px;

    h3 {
      border-bottom: 1px solid #eee;
      padding: 0 15px 10px;
    }

    .list {
      padding: 15px 15px 0;
      display: flex;
      flex-flow: wrap;
      font-size: 14px;

      .list-item {
        width: 100%;
        margin-bottom: 10px;

        span:first-child {
          color: #666;
        }
      }

      .max {
        width: 100%;
        font-weight: bold;
        font-size: 16px;
      }
    }
  }
}

.footer-btn {
  position: fixed;
  left: 5%;
  bottom: 40px;
  width: 90%;
  display: flex;
  justify-content: space-between;

  .van-button {
    width: 100%;
    border-radius: 8px;
  }
}
</style>
